/*
 * this file save the corresponding name of the differents
 * (screens / pages) used for grouping the components and make just a single request
 */

export const COMPONENTS = {
  FOOTER: 'Footer',
  LOGO: 'Logo',
  MODAL_LITE_T: 'ModalLiteT',
  NAVIGATION_BAR: 'NavigationBar',
  ENGLISH_TEST_RESULT_SCREEN: 'EnglishTestResultScreen',
  ENGLISH_TEST_SCREEN: 'ENGLISH_TEST_SCREEN',
  HOME_SCREEN: 'HomeScreen',
  JOB_SCREEN: 'JOB_SCREEN',
  JOBS_SCREEN: 'JOBS_SCREEN',
  LITE_THINKING_SCREEN: 'LITE_THINKING_SCREEN',
  NEXT_EVENT_SCREEN: 'NextEventScreen',
  PRE_REGISTER_SCREEN: 'PRE_REGISTER_SCREEN',
  SERVICES_SCREEN: 'SERVICES_SCREEN',
  CONSULTING_SERVICE_SCREEN: 'ConsultingServiceScreen',
  COURSE_INFO_SCREEN: 'COURSE_INFO_SCREEN',
  FORM_INSCRIPTION: 'FORM_INSCRIPTION',
  INTERES_AREA_SCREEN: 'INTERES_AREA_SCREEN',
  ORGANIZATIONAL_CONSULTING_SCREEN: 'OrganizationalConsultingScreen',
  TI_SERVICE_SCREEN: 'TIServiceScreen',
  TI_SOLUTIONS_SCREEN: 'TISolutionsScreen',
  TRAININGS_SCREEN: 'TRAININGS_SCREEN',
  OUR_PARTNERS: 'OurPartners',
  OUR_PORTFOLIO_SECTION: 'OUR_PORTFOLIO_SECTION',
  LT_NEWS_VIEWER: 'LT_NEWS_VIEWER',
  ENGLISH_SCREEN: 'ENGLISH_SCREEN',
  HOME_IA_SECTION: 'HOME_IA_SECTION',
  HOME_SERVICES_SECTION: 'HOME_SERVICES_SECTION',
  HOME_REINVENT_SECTION: 'HOME_REINVENT_SECTION',
  DETAIL_COURSE_INFORMATION: 'DETAIL_COURSE_INFORMATION',
  HOME_INTRODUCTORY_BANNER_SECTION: 'HOME_INTRODUCTORY_BANNER_SECTION',
  FORM_INTEREST_REGISTER: 'FORM_INTEREST_REGISTER', //InterestRegisterForm
  HOME_VIDE_SECTION: 'HOME_VIDE_SECTION',
  HOME_FEEDBACK_SECTION: 'HOME_FEEDBACK_SECTION',
  COURSE_MOTIVATE_SECTION: 'COURSE_MOTIVATE_SECTION',
  FORM_REGISTER_POPUP: 'FORM_REGISTER_POPUP',
  COURSE_CARD_BUY: 'COURSE_CARD_BUY',
  DETAIL_INTRODUCTORY_ARTICLE: 'DETAIL_INTRODUCTORY_ARTICLE',
  // HOME_INTRODUCTORY: 'HOME_INTRODUCTORY',
  PAYMENTS_METHODS_SECTION: 'PAYMENTS_METHODS_SECTION',
  CERTIFICATION_CARROUSEL_SECTION: 'CERTIFICATION_CARROUSEL_SECTION',
  CONTENT_CARROUSEL_SECTION: 'CONTENT_CARROUSEL_SECTION',
  TI_SOFTWARE_SERVICES_SECTION: 'TI_SOFTWARE_SERVICES_SECTION',
  CARD_DETAIL_COURSE: 'CARD_DETAIL_COURSE',
  MEMBERSHIP_INTEREST_SECTION: 'MEMBERSHIP_INTEREST_SECTION',
  MEMBERSHIP_COMPANY: 'MEMBERSHIP_COMPANY',
  SERVICE_PROGRAM_SECTION: 'SERVICE_PROGRAM_SECTION',
  CONSULTANTS_LT_SECTION: 'CONSULTANTS_LT_SECTION',
  STRATEGIC_PARTNERS_SECTION: 'STRATEGIC_PARTNERS_SECTION',
  BENEFECITS_CERTIFICATIONS_SECTION: 'BENEFECITS_CERTIFICATIONS_SECTION',
  YOUR_COMPANY_LT_DESEVERE: 'YOUR_COMPANY_LT_DESEVERE',
  SOLVE_QUESTIONS_SECTION: 'SOLVE_QUESTIONS_SECTION',
  BANNER_PRINCIPAL_SECTION: 'BANNER_PRINCIPAL_SECTION',
  DOCUMENTS: 'DOCUMENTS',
  ACCOUNT_VERIFICATION: 'ACCOUNT_VERIFICATION',
  PAYMENTS_POLICES_OF_USAGE: 'PAYMENTS_POLICES_OF_USAGE',
  PAYMENTS_PRIVACITY_POLICIES: 'PAYMENTS_PRIVACITY_POLICIES',
  PORTFOLIO: 'PORTFOLIO',
  JOBS_SECTION: 'JOBS_SECTION',
  LT_SEARCH: 'LTInTheWorld',
  STRATEGIC_LINE: 'STRATEGIC_LINE',
  WHY_LT_SERVICES: 'WHY_LT_SERVICES',
  WHY_CHOISE_LT_SECTION: 'WHY_CHOISE_LT_SECTION',
  NEWS: 'NEWS',
  EVENTS: 'EVENTS',
  ABOUT: 'ABOUT',
  ROLE: 'ROLE',
  COUNTRY: 'COUNTRY',
  REFERENCE_TYPES: 'REFERENCE_TYPES',
  VARIABLE: 'VARIABLE',
  CITY: 'CITY',
  CONTRACT_TYPE: 'CONTRACT_TYPE',
  WORK_TYPE: 'WORK_TYPE',
  WORK_SCHEDULE: 'WORK_SCHEDULE',
  EXPERIENCE_LEVEL: 'EXPERIENCE_LEVEL',
  SECTOR: 'SECTOR',
  JOB_CONFIDENTIAL: 'JOB_CONFIDENTIAL',
  KEYWORD: 'KEYWORD',
  PHONE_TYPE: 'PHONE_TYPE',
  WEIGHT_RESUME: 'WEIGHT_RESUME',
  FIT_PORT_JOB: 'FIT_PORT_JOB',
  // COMPONENRTE PARA LAS RUTAS DEL PORTAFOLIO
  LEARNING_ROUTES: 'LEARNING_ROUTES',
  // COMPONENTE PARA WHATSAPP
  WHATSAPP_BUTTON: 'WHATSAPP_BUTTON',
  BROCHURE_PDF: 'BROCHURE_PDF'
};
